import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [partners, setPartners] = useState([]);
  const [config, setConfig] = useState({ whatsapp: "5543999601156", company_name: "DeskcodeBR", company_email: "contato@deskcodebr.com.br" });
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const [c, s, t, f, p, cfg] = await Promise.all([
        api.get("/site-content"),
        api.get("/services"),
        api.get("/testimonials"),
        api.get("/faqs"),
        api.get("/partners"),
        api.get("/config/public"),
      ]);
      setContent(c.data || {});
      setServices(s.data || []);
      setTestimonials(t.data || []);
      setFaqs(f.data || []);
      setPartners(p.data || []);
      setConfig(cfg.data || config);
    } catch (e) {
      console.error("Erro ao carregar conteúdo", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SiteContext.Provider value={{ content, services, testimonials, faqs, partners, config, loading, refresh }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
